import {
  all,
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import {
  types,
  IEditor,
  IGroupEditorsData,
  IGetGroupEditorsAction,
} from '../types/editorsPerGroup'
import * as actions from '../actions/editorsPerGroup'
import * as services from '../services/groups'
import { trace, createArray } from '../services/common'

export function* getGroupEditorsSaga({ groupId, params: customParams }: IGetGroupEditorsAction) {
  try {
    const params = { skip: 0, take: 100, ...customParams }
    const firstCallData = yield call(services.getGroupEditors, groupId, params)
    const amountOfPages = Math.ceil(firstCallData.totalCount / params.take)

    const subsequentCalls = createArray(amountOfPages - 1)
      .map(
        (_: any, index: number) => call(
          services.getGroupEditors,
          groupId,
          { ...params, skip: (index + 1) * params.take }
        )
      )
    const subsequentCallsData = yield all(subsequentCalls)

    const editorsData = subsequentCallsData.reduce(
      (allData: IGroupEditorsData, nextDataChunk: IGroupEditorsData) => ({
        ...allData,
        items: [...allData.items, ...nextDataChunk.items],
      }),
      firstCallData
    )
    editorsData.items = editorsData.items
      .sort((a: IEditor, b: IEditor) => a.lastName.localeCompare(b.lastName))

    yield put(actions.getGroupEditorsSuccess(groupId, { ...editorsData, isLoading: false, isFailed: false }))
  } catch (err) {
    trace(err)
    yield put(actions.getGroupEditorsFailure(
      err.message,
      groupId,
      { items: null, totalCount: null, isLoading: false, isFailed: true }
    ))
  }
}

export function* editorsPerGroupWatcher() {
  yield takeLatest(types.GET_GROUP_EDITORS__STARTED, getGroupEditorsSaga)
}
